<nav class="navbar">
  <a (click)="backToDashboard()" class="js-scroll-trigger clsCursorPointer">
    <img
      src="../../../assets/images/lighthouse-logo.svg"
      id="layoutLogo"
    />
  </a>
</nav>
<div class="container-fluid clsLandingContainer no-padding">
  <div class="row">
    <div class="col-12 no-padding">
      <div class="row">
        <div
          *ngIf="newAsset"
          class="container-fluid clsContainerReadyToStart no-padding"
        >
          <div class="row">
            <div
              class="col-12 text-center pb-3"
              id="divIconProcess"
              style="display: none"
            >
              <img
                alt=""
                src="../../../assets/images/icons/app_process.svg"
                width="68"
                height="68"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12 clsReadyToStart_Title pb-3" id="divLnaTitleText">
              {{ 'component.readytostart.text' | translate }}
            </div>
          </div>
          <div class="row">
            <div
              class="col-12 clsReadyToStart_Subtitle pb-3"
              id="divLnaSubtitleText"
            >
              {{ 'component.readytostart.registeryourapp' | translate }}
            </div>
          </div>
        </div>
        <div
          *ngIf="!newAsset"
          class="container-fluid clsContainerReadyToStart"
        >
          <div class="row">
            <div
              class="col-12 text-center pb-3"
              id="divIconProcess"
              style="display: block"
            >
              <img
                *ngIf="createdAsset === onboardingFormType.Application"
                alt=""
                src="../../../assets/images/icons/app_process.svg"
                width="68"
                height="68"
              />
              <img
                *ngIf="createdAsset === onboardingFormType.Library"
                alt=""
                src="../../../assets/images/icons/library_process.svg"
                width="68"
                height="68"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12 clsReadyToStart_Title pb-3" id="divLnaTitleText">
              {{ 'component.readytostart.onboardinginprocess' | translate }}
            </div>
          </div>
          <div class="row">
            <div
              class="col-12 clsReadyToStart_Subtitle pb-3"
              id="divLnaSubtitleText"
            >
              {{ beingOnboardedTitle | translate }}
            </div>
          </div>
          <div class="row">
            <div
              class="col-12 text-center pb-4"
              id="divBtnTakeatourTop"
              style="display: block"
            >
              <button class="clsButtonTakeATour" (click)="takeATour()">
                {{ 'component.readytostart.takeatour' | translate }} &nbsp;
                <img
                  alt=""
                  class="clsIconButtonGetStarted"
                  src="../../../assets/images/icons/arrow_right_darkblue.svg"
                  width="15"
                  height="15"
                />
              </button>
            </div>
          </div>
          <div class="row">
            <div
              class="col-12 clsReadyToStart_Subtitle pt-3"
              id="divLnaOr"
              style="display: block"
            >
              {{ 'component.readytostart.or' | translate }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="add-assets-container">
            <div
              class="clsContainerReadyToStart_AddYourAsset text-center"
            >
              <a (click)="navigateToAppOnboarding()">
                <div class="row h-100">
                  <div class="col-12 mt-auto">
                    <img
                      alt=""
                      src="../../../assets/images/icons/add_darkblue.svg"
                      width="68"
                      height="68"
                    />
                  </div>
                  <div class="col-12 clsReadyToStartAddYourAsset">
                    {{ 'component.readytostart.addyourapp' | translate }}
                  </div>
                </div>
              </a>
            </div>
            <div *ngIf="isCreateLibraryEnabled()"
              class="clsContainerReadyToStart_AddYourAsset text-center"
            >
              <a (click)="navigateToLibraryOnboarding()">
                <div class="row h-100">
                  <div class="col-12 mt-auto">
                    <img
                      alt=""
                      src="../../../assets/images/icons/add_darkblue.svg"
                      width="68"
                      height="68"
                    />
                  </div>
                  <div class="col-12 clsReadyToStartAddYourAsset">
                    {{ 'component.readytostart.addyourlibrary' | translate }}
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="backToDashboard-section">
          <button
            class="backToDashboard-button"
            [style.visibility]="user.applications.length > 0 ? 'visible' : 'hidden'"
            (click)="backToDashboard()"
          >
            back to lighthouse
            <img src="../../../assets/images/icons/arrow-right-icon.svg" />
          </button></div>
        </div>
      </div>
      <div
        class="row clsSectionSeparation clsReadyToStart_BGBlue"
        [ngClass]="{
          moreBottom: newAsset,
          lessBottom: !newAsset
        }"
      ></div>
    </div>
  </div>
</div>
